import { Controller } from "@hotwired/stimulus"

// Promo code block on the BD payment page. Mirrors shopping-cart cart_controller:
// - toggle: reveals the input on first click of the eyebrow link
// - remove: clears the input, sets remove_discount=true, submits the form
//
// The actual apply round-trip is the form's normal submit (turbo_stream).
export default class extends Controller {
  static targets = ["trigger", "row", "input", "removeDiscount"]

  toggle() {
    if (!this.hasRowTarget) return
    this.rowTarget.hidden = false
    if (this.hasTriggerTarget) this.triggerTarget.hidden = true
    if (this.hasInputTarget) this.inputTarget.focus()
  }

  remove(event) {
    event.preventDefault()
    if (this.hasInputTarget) this.inputTarget.value = ""
    if (this.hasRemoveDiscountTarget) this.removeDiscountTarget.value = "true"
    const form = this.element.closest("form")
    // Use the Appliquer button (formnovalidate) as submitter so the parent
    // form's HTML5 required check doesn't fire on remove.
    const submitter = this.element.querySelector(".bd-promo-apply")
    if (submitter) {
      form.requestSubmit(submitter)
    } else {
      form.requestSubmit()
    }
  }
}
